<div class="main-wrapper">
    <div class="successfull-container">
        <!-- Logo -->
        <div class="successfull-center">
            <img src="../../../assets/svg/atoms-icon-box.svg" alt="Success" loading="lazy">
            <h2>{{ 'auth.password-reset-success.title' | translate }}</h2>
            <p>{{ 'auth.password-reset-success.description1' | translate }}<br> {{ 'auth.password-reset-success.description2' | translate }}</p>
        </div>
         <!-- Login Form -->
        <form class="successfull-form">
            <button type="submit" class="successfull-btn" (click)="onContinue()" aria-label="Continue">{{ 'buttons.continue' | translate }}</button>
        </form>
    </div>
</div>